<div>
    <div class="left">
        <img [src]="imgSrc" />
    </div>
    <div class="right">
        <span>{{ text }}</span>
    </div>
</div>
